// extracted by mini-css-extract-plugin
export default {"modalBody":"GeneratedMoviesWarningModal_modalBody__MRUB+","modalTitle":"GeneratedMoviesWarningModal_modalTitle__4Nn3L","actionBtns":"GeneratedMoviesWarningModal_actionBtns__Zg5uN"};